import { StoreDebugService } from './shared/services/store-debug.service';
import { AnalyticsService } from '@shared/services/analytics.service';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { fetchSettings } from 'src/main';

@Component({
  selector: 'obc-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, AfterViewInit {
  loading = true;
  dynatraceId: string;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private analyticsService: AnalyticsService,
    private storeDebugService: StoreDebugService
  ) {
    this.analyticsService.initAdobeLaunchDataLayer();
    this.analyticsService.injectAdobeLaunchScript();
    const load = async () => {
      const config = await fetchSettings();

      if (!config && !config.dynatrace && !config.dynatrace) return;
      this.dynatraceId = config.dynatrace;

      const scriptId = 'dynatrace';

      if (document.getElementById(scriptId)) return;

      const dynatraceScript = document.createElement('script') as HTMLScriptElement;
      dynatraceScript.type = 'text/javascript';
      dynatraceScript.crossOrigin = 'anonymous';
      dynatraceScript.src = `https://js-cdn.dynatrace.com/jstag/157944990f8/bf42302wlm/${this.dynatraceId}_complete.js`;

      document.getElementsByTagName('head')[0].appendChild(dynatraceScript);
    };
    load();

    const loadAnalyticsGA = async () => {
      const config = await fetchSettings();

      if (!config && !config.analytics && !config.analytics.gtm) return;
      // this.analytics = config.analytics;

      const scriptId = 'google-analytics';

      if (document.getElementById(scriptId)) {
        return;
      }

      const scriptHead = document.createElement('script') as any;
      scriptHead.type = 'text/javascript';
      scriptHead.id = scriptId;

      scriptHead.innerText =
        // tslint:disable-next-line: max-line-length
        `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${config.analytics.gtm}');`;

      document.getElementsByTagName('head')[0].appendChild(scriptHead);

      const scriptBody = document.createElement('noscript');
      scriptBody.innerHTML =
        // tslint:disable-next-line: max-line-length
        `<iframe src="https://www.googletagmanager.com/ns.html?id=${config.analytics.gtm}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

      document.body.insertBefore(scriptBody, document.body.firstChild);
    };
    loadAnalyticsGA();

    // const loadAnalyticsAdobe = async () => {
    //   const config = await fetchSettings();

    //   if (!config && !config.analytics_adobe) return;

    //   const scriptId = 'analytics-adobe';

    //   if (document.getElementById(scriptId)) return;

    //   const adobeScript = document.createElement('script') as HTMLScriptElement;
    //   adobeScript.async = true;
    //   adobeScript.src = `https://assets.adobedtm.com/232caedc0ec1/69b36b1ef5df/launch-${config.analytics_adobe}.min.js`;

    //   document.getElementsByTagName('head')[0].appendChild(adobeScript);
    // };
    // loadAnalyticsAdobe();
  }

  ngOnInit(): void {
    // forced commit 1

    this.translate.addLangs(['pt-br']);
    this.translate.setDefaultLang('pt-br');
  }

  ngAfterViewInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.loading = false;
      }
    });
  }
}
